<template>
  <div class="final-break-dowm-list">
    <div class="top-label" v-if="listViewHeaderName == 'Product Fees'">
      <h2>{{ listViewHeaderName }}</h2>
    </div>
    <div class="top-label" v-else>
      <h2>{{ listViewHeaderName }} breakdown</h2>
    </div>
    <section class="section is-main-section no-padding">
      <circul8-table
        :records="tableData"
        :fields="columns"
        :usePropRecords="true"
        :listingComponent="true"
        :isCheckable="false"
        :maxTextLength="'24'"
        :backendSortingEnabled="true"
        @backendSort="sortData"
        :showRemoveButton="false"
        :showEditButton="true"
        :routeNext="false"
        @querySet="searchByFilter"
        @loadNextPage="pullNextPage"
        :enableInfiniteScroll="true"
        :hasNextData="nextData"
        :hasPreviousData="previousData"
        @loadPreviousPage="pullPreviousPage"
        :showViewButton="false"
      />
      <div class="records-displayed" v-if="totalRecords > 0">
        <span v-if="currentPage * 50 + 50 < totalRecords"
          >displaying {{ currentPage * 50 }} -
          {{ currentPage * 50 + tableData.length }} records out of
          {{ totalRecords }} records</span
        >
        <div v-else>
          <span v-if="currentPage == 0">
            displaying 0 - {{ totalRecords }} records out of
            {{ totalRecords }} records
          </span>
          <span v-else>
            displaying {{ currentPage * 50 - 50 }} - {{ totalRecords }} records
            out of {{ totalRecords }} records
          </span>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Circul8Table from "../../components/Circul8Table.vue";
let screenPixelSize;
let pixelRatio;
export default {
  name: "FinalBreakdownList",
  components: { Circul8Table },
  props: {
    listViewHeaderName: {
      type: String,
      default: ""
    },
    data: [],
    header: [],
    next: {
      type: String,
      default: ""
    },
    previous: {
      type: String,
      default: ""
    },
    count: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      tblName: "breakdown",
      tableData: [],
      isDataLoading: false,
      isModalActive: false,
      action: null,
      isAdd: false,
      viewOnly: false,
      nextPageCursor: "",
      PreviousPageCursor: "",
      loadMoreClicked: false,
      lastSortColumn: null,
      lastSortOrder: null,
      enableLoadMore: false,
      totalRecords: 0,
      isLoading: true,
      nextData: false,
      previousData: false,
      currentPage: 0,
      query: "",
      columns: [],
      isColumnCreated: false
    };
  },
  watch: {
    header(newValue) {
      this.isColumnCreated ? "" : this.prepareColumns(newValue);
    },
    count(newValue) {
      this.totalRecords = newValue;
    },
    next(newValue) {
      this.nextPageCursor = newValue;
    },
    data(newValue) {
      this.PreviousPageCursor = this.nextPageCursor
        ? this.nextPageCursor
        : this.PreviousPageCursor;
      this.nextPageCursor = this.next;
      if (this.currentPage > 0) {
        this.previousData = true;
        if (this.nextPageCursor != null) {
          this.enableLoadMore = this.nextData = true;
        } else {
          this.enableLoadMore = this.nextData = false;
        }
      } else {
        this.enableLoadMore = this.previousData = false;
        if (this.nextPageCursor != null) {
          this.enableLoadMore = this.nextData = true;
        } else {
          this.enableLoadMore = this.nextData = false;
        }
      }
      if (this.nextPageCursor == null) {
        this.tableData.push(...newValue);
        if (this.currentPage == 0) {
          this.previousData = false;
        } else {
          this.currentPage = this.currentPage - 1;
        }
      } else {
        this.tableData = newValue;
      }
      //this.tableData = newValue;
    }
  },
  updated() {
    const listElm = document.querySelector(".table-wrapper");
    listElm.addEventListener("scroll", e => {
      if (
        Math.round(listElm.scrollTop) +
          Math.round(listElm.clientHeight) -
          Math.round(listElm.scrollHeight) >=
        -5
      ) {
        if (this.nextData) {
          listElm.scrollTop = 50;
          this.pullNextPage();
        }
      } else {
        if (Math.round(listElm.scrollTop) == 0 && this.previousData) {
          listElm.scrollTop =
            Math.round(listElm.scrollHeight) -
            Math.round(listElm.clientHeight) -
            50;
          this.pullPreviousPage();
        }
      }
      this.checkSize();
      this.adjustHeight();
    });
  },
  methods: {
    checkSize() {
      screenPixelSize = screen.width;
      pixelRatio =
        window.devicePixelRatio ||
        window.screen.availWidth / document.documentElement.clientWidth;
      pixelRatio = pixelRatio.toFixed(1);
      if (
        (screenPixelSize > 1024 &&
          screenPixelSize < 1281 &&
          pixelRatio == 1.5) ||
        (screenPixelSize > 1580 && screenPixelSize < 1921 && pixelRatio == 1.5)
      ) {
        this.subHeight = this.subHeight - 15;
      }
    },

    adjustHeight() {
      const browser_height = window.innerHeight;
      const newTableHeight = browser_height - this.subHeight;
      document.querySelector(".table-wrapper").style.maxHeight =
        newTableHeight + "px";
    },
    prepareColumns(columns) {
      this.columns = [];
      Object.keys(columns).forEach(element => {
        this.columns.push({
          field: element,
          width: "250",
          label: columns[element],
          searchable: true,
          type: "input",
          filterKey: { element: "" }
        });
      });
      this.columns.push({
        field: "actions",
        label: "",
        headerClass: "is-actions",
        cellClass: "is-actions",
        visible: true,
        searchable: true,
        type: "actionSearch",
        actionSearch: true,
        filterKey: { actions: "" }
      });
      this.isColumnCreated = true;
    },
    pullNextPage() {
      this.previousData = true;
      this.loadMoreClicked = true;
      this.currentPage = this.currentPage + 1;
      const temp = this.nextPageCursor.split("?")[1].split("&");
      const query_part = temp.filter(function(value) {
        return value.indexOf("page=") == -1;
      });
      if (this.nextPageCursor != null || this.nextPageCursor != undefined) {
        this.query =
          "&" + query_part.join("&") + "&page=" + (this.currentPage + 1) + "&";
        this.$emit("loadData", this.query);
        //this.fetchScopeData(this.query);
      }
    },
    pullPreviousPage() {
      this.nextData = true;
      this.loadMoreClicked = true;
      const temp = this.PreviousPageCursor.split("?")[1].split("&");
      let query_part = temp.filter(function(value) {
        return value.indexOf("page=") == -1;
      });
      query_part = [...new Set(query_part)];
      if (this.currentPage == 0 || this.currentPage == 1) {
        this.query = "&" + query_part.join("&") + "&page=1&";
        this.previousData = false;
      } else {
        this.query =
          "&" + query_part.join("&") + "&page=" + this.currentPage + "&";
      }
      this.currentPage =
        this.currentPage > 0 ? this.currentPage - 1 : this.currentPage;
      this.$emit("loadData", this.query);
      //this.fetchScopeData(this.query);
    },
    searchByFilter(filterQuery) {
      this.nextPageCursor = null;
      this.currentPage = 0;
      this.tableData = [];
      this.nextData = false;
      this.query = "&" + filterQuery;
      //      this.displayedRecords = 0;

      let query = "";
      if (this.lastSortColumn) {
        query += "&breakdown_order_field" + "=" + this.lastSortColumn;
        query += "&breakdown_order_by" + "=" + this.lastSortOrder;
        query += this.query;
      } else {
        query = this.query;
      }
      this.$emit("loadData", query);
      //this.fetchScopeData(query);
    },
    sortData(field, order) {
      this.loadMoreClicked = false;
      this.nextPageCursor = null;
      this.currentPage = 0;
      this.tableData = [];
      this.nextData = false;
      // sort should always fetch page 1, so removing page param if exist
      this.query = this.query.replace(/page=[0-9.]{1,2}&/g, "");
      const oldOrderField =
        "&breakdown_order_field" + "=" + this.lastSortColumn;
      const oldOrderValue = "&breakdown_order_by" + "=" + this.lastSortOrder;
      const newOrderField = "&breakdown_order_field" + "=" + field;
      const newOrderValue = "&breakdown_order_by" + "=" + order;

      this.query = this.replaceOrAddParanInSearchQuery(
        oldOrderField,
        newOrderField
      );
      this.query = this.replaceOrAddParanInSearchQuery(
        oldOrderValue,
        newOrderValue
      );

      //     this.displayedRecords = 0;
      this.lastSortColumn = field;
      this.lastSortOrder = order;
      this.$emit("loadData", this.query);
      //this.fetchScopeData(this.query);
    },

    replaceOrAddParanInSearchQuery(oldParam, newParam) {
      if (this.query.includes(oldParam)) {
        this.query = this.query.replace(oldParam, newParam);
      } else {
        this.query += newParam;
      }
      return this.query;
    }
  }
};
</script>
